import { cva } from 'class-variance-authority';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { cn } from '../../../lib/lib';

export interface JoinClubButtonProps {
  onClick?: () => void;
  text: string;
  size: 'medium' | 'large';
  className?: string;
}

const variants = cva(
  `rounded-full border-none font-bold text-center text-white bg-[url('/assets/images/subscription/join_club_bg.svg')] bg-center bg-no-repeat bg-cover stroke-1 py-1 px-1 flex items-center justify-center`,
  {
    variants: {
      size: {
        medium: 'h-[25px] w-[72px] xs:w-[82px] md:h-[27px] md:w-[92px]',
        large: 'h-[33px] w-[125px] md:h-[27px] md:w-[92px] ',
      },
    },
    defaultVariants: {
      size: 'medium',
    },
  }
);

export function JoinClubButton({
  onClick,
  text,
  size,
  className,
}: Readonly<JoinClubButtonProps>) {
  return (
    <ClickableDiv
      className={cn(variants({ size }), className)}
      onClick={onClick}
    >
      <span className="xs:text-xs text-2xs w-full uppercase">{text}</span>
    </ClickableDiv>
  );
}
